import { render, staticRenderFns } from "./PaymentsSvg.vue?vue&type=template&id=2aaa50b2"
import script from "./PaymentsSvg.vue?vue&type=script&lang=js"
export * from "./PaymentsSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports